import { Component, OnInit } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { SubmissionService } from '../_services/submission.service';
import { ContractService } from '../_services/contract.service';
import { ClientService } from 'app/_services/client.service';
import { BuildingService } from 'app/_services/building.service';
import { PropositionService } from 'app/_services/proposition.service';
import { TemplateService } from '../_services/template.service';
import { NoteService } from 'app/_services/note.service';
import { FileService } from 'app/_services/file.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import flatpickr from "flatpickr";
import * as moment from 'moment'; 

@Component({
  selector: 'app-contracts',
  templateUrl: './edit-contract.component.html',
  styleUrls: ['./contracts.component.scss'] 
})
export class EditContractComponent implements OnInit {
  baseUrl = environment.baseUrl;
  contactUUID: string = "";
  submissionId: number = 0;
  clientId: number = 0;
  clientInfo: any = [];
  buildingId: number = 0;

  roofTypesList: any = [];
  roofAccessList: any = [];
  buildingTypesList: any = [];
  buildingAccessTypesList: any = [];
  buildingInfo: any = [];
  templatesList: any = [];
  propositionsList: any = [];
  contractInfo: any = {};
  
 //files: any = "";
 fileList: File[] = [];
 uploadedFiles: any = [];
 filesUpload: any = [];
 fileName: string = '';
 fileSize: number = 0;

 propositionTemplateId: number = 0;
 propositionTemplateName: string = "";
 propositionTemplate: any = "";
 propositionEmailDate: any = "";

 singleProposition: any = [];
 propositionId: number = 0;
 propositionName: string = "";
 propositionContent: any = "";
 update_message: string = "";
 update_message_prop: string = "";
 suiviNotesList: any = [];
 calendarPick: any;

  editContractForm: FormGroup = new FormGroup({
    is_refused: new FormControl(""),
    is_scheduled: new FormControl(""),
    is_sent: new FormControl(""),
    is_accepted: new FormControl(""),
    is_signed: new FormControl(""),
    is_scanned: new FormControl(""),
    has_invoice: new FormControl(""),
    has_invoice_sent: new FormControl(""),
    fileList: new FormControl(""),
    uploadedFiles: new FormControl(""),

    submission_no: new FormControl(""),
    soumission_created_date: new FormControl(""),
    created_by_name: new FormControl(""),
    latest_appointment_date: new FormControl(""),
    is_job_planned: new FormControl(""),
    latest_job_date: new FormControl(""),
    build_date: new FormControl(""),

    building_updated: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    country: new FormControl(""),
    postalcode: new FormControl(""),
    roof_type_id: new FormControl(""),
    roof_description: new FormControl(""),
    roof_access: new FormControl(""),
    roof_date: new FormControl(""),
    is_roof_redone: new FormControl(""),
    is_new: new FormControl(""),
    building_type_id: new FormControl(""),
    building_description: new FormControl(""),
    building_access_id: new FormControl(""),
    has_water_infiltration: new FormControl(""),
    water_infiltration: new FormControl(""),
    building_age: new FormControl(""), //owner sincee
    description: new FormControl(""),
    is_suivi_active: new FormControl(""),
   
  })

  addPropositionForm: FormGroup = new FormGroup({
    proposition_name: new FormControl(""),
    proposition_content: new FormControl("")
  })

  updatePropositionForm: FormGroup = new FormGroup({
    proposition_name: new FormControl(""),
    proposition_content: new FormControl("")
  })

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private submissions: SubmissionService,
    private clients: ClientService,
    private buildings: BuildingService,
    private templates: TemplateService,
    private propositions: PropositionService,
    private notes: NoteService,
    private files: FileService
  ) { }

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.submissionId = this.activatedRoute.snapshot.params['submissionid'];
    moment.locale('fr');

    this.submissions.getRoofTypes$(this.contactUUID).subscribe({
      next: data => {
        this.roofTypesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching roof types: ", err)
      }
    });
    
    this.buildings.getBuildingTypes$(this.contactUUID).subscribe({
      next: data => {
        this.buildingTypesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching building types: ", err)
      }
    });
    
    this.submissions.getRoofAccessTypes$(this.contactUUID).subscribe({
      next: data => {
        this.buildingAccessTypesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching roof access types: ", err)
      }
    });

    this.templates.getTemplatesList$(this.contactUUID).subscribe({
      next: data => {
        this.templatesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching templates: ", err)
      }
    });

    //type one is notes of submission
    this.notes.getNotesOfSubmission$(this.contactUUID, 1, this.submissionId).subscribe({
      next: data => {
        this.suiviNotesList = data //.reverse();
        console.log('this.suiviNotesList', this.suiviNotesList);

        for (let suiviNote of this.suiviNotesList ){
          suiviNote.created = moment(new Date(suiviNote.created)).locale('fr').format('D MMMM YYYY LT');
          suiviNote.start_date = moment(new Date(suiviNote.start_date)).locale('fr').format('D MMMM YYYY LT');
          suiviNote.end_date = moment(new Date(suiviNote.end_date)).locale('fr').format('D MMMM YYYY LT');
        }
                  //suivis
                  
                  for (let i = 0; i < this.suiviNotesList.length; i++) {
                    this.editContractForm.addControl('note_id_'+i, new FormControl(""));
                    this.editContractForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
                    this.editContractForm.addControl('note_start_date_'+i, new FormControl(""));
                    this.editContractForm.controls['note_start_date_'+i].patchValue(this.suiviNotesList[i].start_date);
                    this.editContractForm.addControl('note_suivi_'+i, new FormControl(""));
                    this.editContractForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
            
                    console.log('i', i, this.suiviNotesList[i]);
                   }
             
              
        console.log('this.suiviNotesList ', this.suiviNotesList );
      },
      error: err => {
        console.log("Something went wrong fetching notes: ", err)
      }
    });

    this.submissions.getSubmission$(this.submissionId, this.contactUUID).subscribe({
      next: data => {

        this.contractInfo = data;
        this.clientId = data.client_id;
        this.buildingId = data.building_id;
        this.uploadedFiles = data.files;

        console.log('this.contractInfo',this.contractInfo);
        console.log('files', this.uploadedFiles);

        this.getClient(this.clientId);
        this.getBuildingInfo(this.buildingId);

        this.contractInfo.latest_appointment_date = (this.contractInfo.latest_appointment_date!= null)? moment(new Date(this.contractInfo.latest_appointment_date)).format('YYYY-MM-DD HH:mm'): '';
        this.contractInfo.latest_job_date = (this.contractInfo.latest_job_date != null)? moment(new Date(this.contractInfo.latest_job_date)).format('YYYY-MM-DD HH:mm') : '';

        this.editContractForm.controls['is_refused'].patchValue(this.contractInfo.is_refused);
        this.editContractForm.controls['is_scheduled'].patchValue(this.contractInfo.is_scheduled);
        this.editContractForm.controls['is_sent'].patchValue(this.contractInfo.is_sent);
        this.editContractForm.controls['is_accepted'].patchValue(this.contractInfo.is_accepted);
        this.editContractForm.controls['is_signed'].patchValue(this.contractInfo.is_signed);
        this.editContractForm.controls['is_scanned'].patchValue(this.contractInfo.is_scanned);
        this.editContractForm.controls['has_invoice'].patchValue(this.contractInfo.has_invoice);
        this.editContractForm.controls['has_invoice_sent'].patchValue(this.contractInfo.has_invoice_sent);
        //submission details
        this.editContractForm.controls['submission_no'].patchValue(this.contractInfo.submission_no);
        this.editContractForm.controls['soumission_created_date'].patchValue(moment(this.contractInfo.created).format('YYYY-MM-DD'));
        this.editContractForm.controls['created_by_name'].patchValue(this.contractInfo.created_by_name);
        this.editContractForm.controls['latest_appointment_date'].patchValue( moment(new Date(this.contractInfo.latest_appointment_date)).format('YYYY-MM-DD HH:mm'));
        this.editContractForm.controls['is_job_planned'].patchValue(this.contractInfo.is_job_planned);
        this.editContractForm.controls['latest_job_date'].patchValue(moment(new Date(this.contractInfo.latest_job_date)).format('YYYY-MM-DD HH:mm'));

         // Building Infos
         this.editContractForm.controls['building_updated'].patchValue(this.contractInfo.building_updated);
         this.editContractForm.controls['build_date'].patchValue( this.contractInfo.build_date);
         this.editContractForm.controls['address'].patchValue(this.contractInfo.address);
         this.editContractForm.controls['address2'].patchValue(this.contractInfo.address2);
         this.editContractForm.controls['city'].patchValue(this.contractInfo.city);
         this.editContractForm.controls['province'].patchValue(this.contractInfo.province);
         this.editContractForm.controls['country'].patchValue(this.contractInfo.country);
         this.editContractForm.controls['postalcode'].patchValue(this.contractInfo.postalcode);
         this.editContractForm.controls['roof_type_id'].patchValue(this.contractInfo.roof_type_id);
         this.editContractForm.controls['roof_description'].patchValue(this.contractInfo.roof_description);
         this.editContractForm.controls['roof_access'].patchValue(this.contractInfo.roof_access);
         this.editContractForm.controls['roof_date'].patchValue(this.contractInfo.roof_date);
         this.editContractForm.controls['is_roof_redone'].patchValue(this.contractInfo.is_roof_redone);
         this.editContractForm.controls['is_new'].patchValue(this.contractInfo.is_new);
         this.editContractForm.controls['building_type_id'].patchValue(this.contractInfo.building_type_id);
         this.editContractForm.controls['building_description'].patchValue(this.contractInfo.building_description);
         this.editContractForm.controls['building_access_id'].patchValue(this.contractInfo.building_access_id);
         this.editContractForm.controls['has_water_infiltration'].patchValue(this.contractInfo.has_water_infiltration);
         this.editContractForm.controls['water_infiltration'].patchValue(this.contractInfo.water_infiltration);
         this.editContractForm.controls['building_age'].patchValue(this.contractInfo.building_age);
         this.editContractForm.controls['description'].patchValue(this.contractInfo.description);
         //files
         this.editContractForm.controls['fileList'].patchValue(this.fileList);
         this.editContractForm.controls['uploadedFiles'].patchValue(this.contractInfo.files);
         //suivis
         this.editContractForm.controls['is_suivi_active'].patchValue(this.contractInfo.is_suivi_active);

         for (let i = 0; i < this.suiviNotesList.length; i++) {
            this.editContractForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
            this.editContractForm.controls['note_start_date_'+i].patchValue(this.suiviNotesList[i].start_date);
            this.editContractForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
         }
     
        this.submissionPropositions(this.submissionId);

        flatpickr("#soumission_created_date", {
          defaultDate: this.contractInfo.created
        });

        setTimeout(() => {
              let suivi_start_date;
              if(this.suiviNotesList.length){
                suivi_start_date = this.suiviNotesList[this.suiviNotesList.length-1].start_date;
              }
              
              console.log('suivi_start_date',suivi_start_date);

              this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
                enableTime:false,
                defaultDate: suivi_start_date, //moment(suivi_start_date).format('YYYY-MM-DD')
                
              });

          }, 500);
/*
        flatpickr("#build_date", {
          defaultDate: this.contractInfo.build_date
        });
*/
      },
      error: err => {
        console.log("Something went wrong fetching submission: ", err)
      }
    });
  }

  // On file Select
  onFileSelected(event: any) {
    this.fileList = event.target.files;

    if (this.fileList) {
      for (let i = 0; i < this.fileList.length; i++) {
        const reader = new FileReader();
        
        reader.readAsDataURL(this.fileList[i]);

        reader.onloadend = () => {
          console.log('file selected', this.fileList[i].name);
          this.filesUpload.push(
            { 
              base64String: reader.result,
              fileName: this.fileList[i].name
            }
          );
        }         
      }
    }
  }

  deleteFile(file: any) {
    const newFileList = Array.from(this.fileList);
    
    this.filesUpload.splice(file, 1)
    newFileList.splice(file, 1);
    this.fileList = newFileList;
    
  }

  // Upload new files
  uploadNewFiles():void  {
    let lastOneReload = false;
      for (let i = 0; i < this.filesUpload.length; i++ ){
        if(i+1 == this.filesUpload.length) {
          lastOneReload = true;
        }
        this.onUpload(this.filesUpload[i],  lastOneReload);
      }
      this.filesUpload =[];
      console.log('uploaded');
  }

  onUpload(oneFile: any, lastOneReload: any): void {
    console.log("upload file: ", oneFile);

    let fileInfos: any = {
      submission_id : this.submissionId,
      file_name : oneFile['fileName'],
      file : oneFile['base64String'],
    }

    this.files.uploadFile$(this.contactUUID, fileInfos).subscribe({
      next: data => {
        // this.clientInfo = data;
        console.log("uploaded: ", data);
        if(lastOneReload){
            window.location.reload();
        }
      },
      error: err => {
        console.log("Something went wrong fetching file: ", err)
      }
    });
  }

  deleteExistingFile(file_id: any, file_name:any) {
    console.log('deleting file id', file_id);

    if(confirm("Voulez-vous supprimer le fichier "+ file_name)) {
      this.files.deleteFile$(this.contactUUID, file_id).subscribe({
        next: data => {
        // this.clientInfo = data;
        console.log("deleted a file successfully: ", data)
        window.location.reload();
        },
        error: err => {
          console.log("Something went wrong deleting a file: ", err)
        }
      });
    }

  }

  getClient(client: number): void {
    this.clients.getClient$(this.contactUUID, client).subscribe({
      next: data => {
        this.clientInfo = data;
      },
      error: err => {
        console.log("Something went wrong fetching the client: ", err)
      }
    });
  }

  getBuildingInfo(buildingId: number): void {
    this.buildings.getBuilding$(this.contactUUID, buildingId).subscribe({
      next: data => {
        this.buildingInfo = data;
      },
      error: err => {
        console.log("Something went wrong fetching building info: ", err)
      }
    });
  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(formValues: any): void {
    console.log("All values ", formValues)

    let submissionStateInfos: any = {
      "submission_state_id": this.contractInfo.submission_state_id,
      "updated": this.contractInfo.state_updated,
      "is_refused": formValues.is_refused,
      "is_sent": formValues.is_sent,
      "is_accepted": formValues.is_accepted,
      "is_signed": formValues.is_signed,
      "is_scanned": formValues.is_scanned,
      "has_invoice": formValues.has_invoice,
      "has_invoice_sent": formValues.has_invoice_sent,
      "is_job_planned": this.contractInfo.is_job_planned,
      "is_suivi_active": formValues.is_suivi_active,
      "suivi_was_active": this.contractInfo.suivi_was_active,
      "is_suivi_rv_active": this.contractInfo.is_suivi_rv_active,
      "is_prep_security_done": this.contractInfo.is_prep_security_done,
      "is_appel_service": this.contractInfo.is_appel_service,
      "is_appel_service_active": this.contractInfo.is_appel_service_active,
    }

    this.submitSubmissionState(submissionStateInfos);

    let submissionInfos: any = {
      "submission_no": formValues.submission_no,
      "client_id": this.contractInfo.client_id,
      "active": this.contractInfo.active,
      "updated": this.contractInfo.updated
    }

    this.submitSubmissionInfo(submissionInfos);

    let buildingInfos: any = {
      "building_id": this.contractInfo.building_id,
      "submission_id": this.contractInfo.submission_id,
      "updated": this.contractInfo.building_updated,
      //work address
      "address": formValues.address,
      "address2": formValues.address2,
      "city": formValues.city,
      "province": formValues.province,
      "country": formValues.country,
      "postalcode": formValues.postalcode,
      //building info
      "roof_type_id": formValues.roof_type_id,
      "roof_description": formValues.roof_description,
      "building_type_id": formValues.building_type_id,
      "building_description": formValues.building_description,
      "building_access_id": formValues.building_access_id,
      "roof_access": formValues.roof_access,
      "has_water_infiltration": formValues.has_water_infiltration,
      "water_infiltration":formValues.water_infiltration,
      //extra info
      "is_new": formValues.is_new,
      "building_age": formValues.building_age,
      "roof_date": formValues.roof_date,
      "is_roof_redone": formValues.is_roof_redone,
      "build_date": formValues.build_date,
      "description": formValues.description,
    }

    this.submitBuildingInfo(buildingInfos);

    console.log('length', this.suiviNotesList.length);

    for (let i = 0; i < this.suiviNotesList.length; i++ ) {

      //console.log('update note', formValues['note_id_0']);
      
      //suivis
      let submissionNoteInfos: any = {
        "note_id" : formValues['note_id_'+i],
        "entity_id": this.contractInfo.submission_id,
        "updated": this.suiviNotesList[i].updated,
        "body": formValues['note_suivi_'+i],
        "start_date": moment(formValues['note_start_date_'+i]).toISOString(),
      }

      console.log('submissionNoteInfos', submissionNoteInfos);

      this.submitSuiviNoteInfo(submissionNoteInfos);
    }

    // Upload files
    this.uploadNewFiles();
    
    //console.log('files upload', this.filesUpload);
  }

  submitSubmissionState(info: any): void {
    this.submissions.updateSubmissionState$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission status: ", data)
        this.contractInfo.state_updated = data.updated;
      },
      error: err => {
        console.log("Something went wrong while updating the submission status: ", err)
      }
    });
  }

  submitSubmissionInfo(info: any): void {
    this.submissions.updateSubmission$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission: ", data);
        this.contractInfo.updated = data.updated;
      },
      error: err => {
        console.log("Something went wrong while updating the submission: ", err)
      }
    });
  }

  submitBuildingInfo(info: any): void {
    this.buildings.updateBuilding$(this.contactUUID, info).subscribe({
      next: data => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the building: ", data);
        this.contractInfo.building_updated = data.updated;
        this.goToTop();
      },
      error: err => {
        console.log("Something went wrong while updating the building info: ", err)
      }
    })
  }

  submitFiles(files: any): void {
    this.notes.uploadFiles$(this.contactUUID, 2, files).subscribe({
      next: data => {
        console.log("Success updating the file(s): ", data)
      },
      error: err => {
        console.log("Something went wrong while updating the file(s): ", err)
      }
    })
  }

  proposition(id: any, name: string): void {
    this.templates.getTemplate$(id, this.contactUUID).subscribe({
      next: data => {
        this.propositionTemplateId = data.template_id;
        this.propositionTemplateName = name;
        this.propositionTemplate = data.template;
      },
      error: err => {
        console.log("Something went wrong while fetching the proposition: ", err)
      }
    });
  }

  submissionPropositions(submissionId: number): void {
    this.propositions.getSubmissionPropositions$(this.contactUUID, submissionId).subscribe({
      next: data => {
        this.propositionsList = data;
        this.propositionsList = data.reverse();
        for (let oneProposition of this.propositionsList ){
          oneProposition.proposition_date = moment(new Date(oneProposition.proposition_date)).locale('fr').format('D MMMM YYYY HH:mm');
        } 
        console.log('this.propositionsList', this.propositionsList);
      },
      error: err => {
        console.log("Something went wrong while submitting the propositions: ", err)
      }
    });
  }

  saveProposition(templateContent: any): void {
    const submissionid = this.activatedRoute.snapshot.params['submissionid'];
    
    const d = new Date(), 
      year = d.getFullYear(),
      month = d.getMonth(),
      day = d.getDate();

    let propositionInfo: any = {
      "submission_id": submissionid,
      "proposition_name": templateContent.proposition_name,
      "proposition_date": d,
      "proposition": templateContent.proposition_content,

    }

    this.propositions.addProposition$(this.contactUUID, propositionInfo).subscribe({
      next: data => {
        const closeButton = document.querySelector(".btn-close") as HTMLElement | null;
        closeButton!.click();

        this.submissionPropositions(submissionid);

        console.log("Success adding proposition: ", data)
      },
      error: err => {
        console.log("Something went wrong while adding proposition: ", err.error.errors)
      }
    });
  }

  updateProposition(propositionContent: any): void {
    const d = new Date(), 
      year = d.getFullYear(),
      month = d.getMonth(),
      day = d.getDate();

    let propositionInfo: any = {
      "proposition_id": this.singleProposition.proposition_id,
      "updated": this.singleProposition.updated,
      "submission_id": this.singleProposition.submission_id,
      "template_id": this.singleProposition.template_id,
      "proposition_name": propositionContent.proposition_name,
      "proposition_date": this.singleProposition.proposition_date,
      "proposition": propositionContent.proposition_content !== "" ? propositionContent.proposition_content : this.propositionContent
    }

    this.propositions.updateProposition$(this.contactUUID, propositionInfo).subscribe({
      next: data => {
        const closeButton = document.querySelector("#updatePropositionForm-close") as HTMLElement | null;
        closeButton!.click();
        
        console.log("Success updating the proposition: ", data)
      },
      error: err => {
        console.log("Something went wrong while updating the proposition: ", err)
      }
    });
  }

  sanitizePhone(phoneNumber: string): string {

    let phoneNumberSanitized = phoneNumber.replace(/\D/g, '');
    phoneNumberSanitized = phoneNumberSanitized.substring(0, 10);
    //console.log('phoneNumberSanitized: ', phoneNumberSanitized);
    return phoneNumberSanitized;
  }

  propositionEdit(proposition: number): void {
    this.propositions.getProposition$(proposition, this.contactUUID).subscribe({
      next: data => {
        this.singleProposition = data;
  
        this.propositionId = this.singleProposition.proposition_id;
        this.propositionName = this.singleProposition.proposition_name;
        this.propositionContent = this.singleProposition.proposition;
      },
      error: err => {
        console.log("Something went wrong while editing the proposition: ", err)
      }
    });
  }

  propositionEmail(proposition: number): void {

    if(confirm("Envoyer cette proposition par courriel? <br> NOM DU CLIENT:"+ this.clientInfo['first_name'] + " " + this.clientInfo.last_name +
    "courriel: " + this.clientInfo['email']
    )) {
      this.propositions.exportPropositionEmail$(this.contactUUID, proposition).subscribe({
        next: data => {
          this.update_message_prop = "Proposition a été envoyée au client avec succèss: "+ data.proposition_name;
          console.log("Success emailing the proposition: ", data);
          window.location.reload();
        },
        error: err => {
          console.log("Something went wrong while emailing the proposition: ", err.error.errors)
        }
      });
    }
  }

  propositionPrint(proposition: number): void {
    this.propositions.exportPropositionPrint$(this.contactUUID, proposition).subscribe({
      next: data => {
        console.log("Success sending emailing the proposition: ", data)

        let printContents, popupWin: any;
        printContents = document.getElementById('print-section')!.innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(data.proposition);
        popupWin.document.close();
        popupWin.window.print();
      },
      error: err => {
        console.log("Something went wrong while emailing the proposition: ", err.error.errors)
      }
    });
  }

  propositionPdf(proposition: number, name: string): void {
    // TO DO Clean up using the service
    this.http.post(this.baseUrl + `/propositions/` + proposition + `/export/pdf?uuid=` + this.contactUUID, proposition, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);

      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;
      // TO OPEN PDF ON BROWSER IN NEW TAB
      window.open(pdfUrl, '_blank');
      // TO DOWNLOAD PDF TO YOUR COMPUTER
      PDF_link.download = name +".pdf";
      PDF_link.click();
    });
  }

  fileExport(fileId: number, name: string, contentType: string): void {
    // TO DO Clean up using the service
    this.http.get(this.baseUrl + `/notes/file/download/` + fileId + `?uuid=` + this.contactUUID, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: contentType });
      let pdfUrl = window.URL.createObjectURL(blob);

      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;

      console.log('link', PDF_link, fileId );
      // TO OPEN PDF ON BROWSER IN NEW TAB
      window.open(pdfUrl, '_blank');
      // TO DOWNLOAD PDF TO YOUR COMPUTER
      //PDF_link.download = name +".pdf";
      //PDF_link.click();
    });
  }

  fileDownload(fileId: number, name: string, contentType: string): void {
    // TO DO Clean up using the service
    this.http.get(this.baseUrl + `/notes/file/download/` + fileId + `?uuid=` + this.contactUUID, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: contentType });
      let pdfUrl = window.URL.createObjectURL(blob);

      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;
      PDF_link.setAttribute("download", name);

      console.log('link', PDF_link, fileId );
      
      // TO DOWNLOAD PDF TO YOUR COMPUTER
      PDF_link.download = name;
      PDF_link.click();

    });
  }
  
  propositionDuplicate(proposition: number, name: string): void {
    const submissionid = this.activatedRoute.snapshot.params['submissionid'];

    this.propositions.duplicateProposition$(this.contactUUID, proposition).subscribe({
      next: data => {
        console.log("Success duplicating the proposition: ", data);
        this.update_message_prop = "Nouvelle proposition ajoutée avec succèss: "+data.proposition_name;
        this.submissionPropositions(submissionid);
      },
      error: err => {
        console.log("Something went wrong while duplicating the proposition: ", err.error.errors)
      }
    });
  }

  submitSuiviNoteInfo(info: any): void {
    this.notes.updateNote$(this.contactUUID, info).subscribe({
      next: data => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the note: ", data);
        this.contractInfo.building_updated = data.updated;
        this.goToTop();
      },
      error: err => {
        console.log("Something went wrong while updating the building info: ", err)
      }
    })
  }

  /*  Add an extra empty suivi field */
  addSuiviNote(): void  {
    const submissionid = this.activatedRoute.snapshot.params['submissionid'];
    
    let submissionNoteInfo: any = {
      "note_type_id": 1,
      "note_entity_id": 2,
      "entity_id": submissionid,
      "subject": '',
      "body": '',
      "start_date": moment(new Date()).add(4, 'days'),
      "end_date":  moment(new Date()).add(4, 'days'),
    }

    this.notes.addSubmissionNote$(this.contactUUID, submissionNoteInfo).subscribe({
      next: data => {
        this.suiviNotesList.push({
          "note_id" : data.note_id,
          "body":  data.body,
          "first_name": data.first_name,
          "last_name": data.last_name,
          "created": moment(data.created).format('YYYY-MM-DD HH:mm') ,
          "start_date": data.start_date,
          "end_date": data.end_date,
          "updated": data.updated,
        })

        /*
        let i = this.suiviNotesList.length-1;
        this.editContractForm.addControl('note_id_'+i, new FormControl(""));
        this.editContractForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
        this.editContractForm.addControl('note_start_date_'+i, new FormControl(""));
        this.editContractForm.controls['note_start_date_'+i].patchValue(this.suiviNotesList[i].start_date);
        this.editContractForm.addControl('note_suivi_'+i, new FormControl(""));
        this.editContractForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
        flatpickr("#note_start_date", { defaultDate: data.start_date });
       // console.log('suivi_start_date',this.editContractForm.controls['note_start_date_'+i]);
        console.log("Success adding suivi note: ", data);
        console.log ('returning suivi note: ', this.suiviNotesList);
        */

        let i = this.suiviNotesList.length-1;
        let default_date = moment(this.suiviNotesList[i].start_date).format('YYYY-MM-DD');
        var next_suivi_date = moment(default_date).add(4, 'days');

        console.log('Adding next date ', next_suivi_date );

  /*
        this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
          defaultDate: moment(default_date).add(4, 'days').format('YYYY-MM-DD'),
        });

        
*/
        
      setTimeout(() => {
          this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
            enableTime: false,
            defaultDate: moment(default_date).format('YYYY-MM-DD'),
        });
      }, 500);


        console.log('this.calendarPick ', this.calendarPick );

        const input = document.querySelector('#note_start_date_pkr_'+Number(this.suiviNotesList.length-1)) as HTMLInputElement | null;
        //window.location.reload();
        const input2 = document.getElementById('#note_start_date_pkr_'+Number(this.suiviNotesList.length-1)) as HTMLInputElement | null;
    

        console.log('iter', this.suiviNotesList.length-1);

        if (input2 != null) {
            console.log('input of calpick', input2.value); // 👉️ "Initial value"
        }else{
          console.log('input of null calpick', input2); 
        }

        this.editContractForm.addControl('note_id_'+i, new FormControl(""));
        this.editContractForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
        this.editContractForm.addControl('note_start_date_'+i, new FormControl(""));
        this.editContractForm.controls['note_start_date_'+i].patchValue( moment(this.suiviNotesList[i].start_date).format('YYYY-MM-DD'));
        this.editContractForm.addControl('note_suivi_'+i, new FormControl(""));
        this.editContractForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
       // console.log('suivi_start_date',this.editSubmissionForm.controls['note_start_date_'+i]);

       
       console.log('DEFAULT start DATE',default_date );
       
     
        console.log("Success adding suivi note: ", data);
        console.log ('returning suivi note: ', this.suiviNotesList);

      },
      error: err => {
        console.log("Something went wrong while adding suivi note: ", err.error.errors)
      }
    });
  }

  deleteSuiviNote(note_order: number, note_id: any) {
    const newSuiviNotesList = Array.from(this.suiviNotesList);
    
    //this.filesUpload.splice(file, 1)
    newSuiviNotesList.splice(note_order, 1);
    this.suiviNotesList = newSuiviNotesList;
    console.log('deleting Note: ', note_id);

    let noteInfo: any = {
      "note_id": note_id,
    }

    this.notes.deleteNote$(this.contactUUID, note_id, noteInfo).subscribe({
      next: data => {
              console.log("Success deleting suivi note: ", data);
              let i = this.suiviNotesList.length-1;
              let default_date = moment(this.suiviNotesList[i].start_date).format('YYYY-MM-DD');
              var next_suivi_date = moment(default_date).add(4, 'days');

              setTimeout(() => {
                this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
                  enableTime: false,
                  defaultDate: moment(default_date).format('YYYY-MM-DD'),
              });
              }, 500);
      },
      error: err => {
        console.log("Something went wrong while deleting suivi note: ", err.error.errors)
      }
    });
    
  }

}